module.exports = require("first-chunk-stream");